import api from '@/utils/api';

/**
 * Delete Product Category
 * @param {string} companyId - the companyId
 * @param {string} productId - the productId
 * @returns {Promise}
 */
const deleteProductCategoryApi = (companyId, productId) =>
  api.delete(`/company/${companyId}/product-category/${productId}`);

export default deleteProductCategoryApi;
